<template>
  <div>
    <center><h2>{{restaurant}}</h2></center>
    <center><h3>{{branch}}</h3></center>
    <center><h4>{{title}}</h4></center>
    <center><h5>{{startDate}} &nbsp; - &nbsp; {{endDate}}</h5></center>
    <center>
      <table style="border-spacing: 0;">
        <thead>
        <tr>
          <th style="width:5%; border: 1px solid black;border-collapse: collapse;font-size:13px;"><small style="margin-left: 5px">Sr.</small></th>
          <th style="width:55%;text-align:left; font-size:14px;border: 1px solid black;border-collapse: collapse;"><small style="margin-left: 5px">{{ itemTitle }}</small></th>
          <th style="width:20%;text-align:left; font-size:14px;border: 1px solid black;border-collapse: collapse;"><small style="margin-left: 5px">Quantity</small></th>
          <th style="width:20%;text-align:center; font-size:14px;border: 1px solid black;border-collapse: collapse;">Total Price</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in filteredSale" :key="index">
          <td style="width:5%;text-align:left; font-size:14px;border: 1px solid black;border-collapse: collapse;"><small style="margin-left: 5px">{{ index+1 }}</small></td>
          <td style="width:55%;text-align:left; font-size:14px;border: 1px solid black;border-collapse: collapse;"><small style="margin-left: 5px">{{ item.itemName }}</small></td>
          <td style="width:20%;text-align:center; font-size:14px;border: 1px solid black;border-collapse: collapse;"><small style="margin-left: 5px">{{ item.quantity }}</small></td>
          <td style="width:20%;text-align:center;font-size:13px;border: 1px solid black;border-collapse: collapse;"><small>{{ item.totalPriceOrderItem }}</small></td>
        </tr>
        </tbody>
      </table><br>
      <table style="border-spacing: 0; border: 1px solid black;border-collapse: collapse;">
      <thead>
      <tr></tr>
      </thead>
      <tbody style="border: 1px solid black;border-collapse: collapse;">
      <tr style="border: 1px solid black;border-collapse: collapse;">
        <td style="text-align:left;font-size:13px; margin-left: 500px; border: 1px solid black;border-collapse: collapse;">Total Sale:</td>
        <td style="text-align:left;font-size:14px;border: 1px solid black;border-collapse: collapse;"><b>Rs.{{ totalSale }}</b></td>
        <td style="text-align:left;font-size:13px; margin-left: 510px;border: 1px solid black;border-collapse: collapse;">Total Delivery Fee:</td>
        <td style="text-align:left;font-size:14px;border: 1px solid black;border-collapse: collapse;"><b>Rs.{{ totalDeliveryFee }}</b></td>
      </tr>
      <tr style="border: 1px solid black;border-collapse: collapse;">
        <td style="text-align:left;font-size:13px; margin-left: 500px;border: 1px solid black;border-collapse: collapse;">Total Tax:</td>
         <td style="text-align:left;font-size:14px;border: 1px solid black;border-collapse: collapse;"><b>Rs.{{ totalTax }}</b></td>
        <td style="text-align:left;font-size:13px; margin-left: 510px;border: 1px solid black;border-collapse: collapse;">Total Discount:</td>
        <td style="text-align:left;font-size:14px;border: 1px solid black;border-collapse: collapse;"><b>Rs.{{ totalDiscount }}</b></td>
      </tr>
      <tr style="border: 1px solid black;border-collapse: collapse;">
        <td style="text-align:left;font-size:13px; margin-left: 500px;border: 1px solid black;border-collapse: collapse;">Total Sale On Card</td>
        <td style="text-align:left;font-size:14px;border: 1px solid black;border-collapse: collapse;"><b>Rs.{{ saleOnCard }}</b></td>
        <td style="text-align:right;font-size:13px; margin-left: 500px;border: 1px solid black;border-collapse: collapse;">Total Sale On Cash:</td>
        <td style="text-align:left;font-size:14px;border: 1px solid black;border-collapse: collapse;"><b>Rs.{{ saleOnCash }}</b></td>
      </tr>
      <tr style="border: 1px solid black;border-collapse: collapse;">
        <td style="text-align:left;font-size:15px; margin-left: 500px;border-collapse: collapse;">Total Net Sale:</td><td></td><td></td>
        <td style="text-align:left;font-size:16px;border-collapse: collapse;"><b>Rs.{{ totalNetSale }}</b></td>
      </tr>
      </tbody>
    </table>
    </center>
  </div>
</template>

<script>
export default {
  name: "SaleReceipt",
  props: {
    sale : {
      type: Array
    },
    title: {
      type: String
    },
    itemTitle: {
      type: String
    },
    restaurant: {
      type: String
    },
    branch: {
      type: String
    },
    startDate: {
      type: String
    },
    endDate: {
      type: String
    }
  },

  computed: {
    totalSale() {
      const totalSaleItem = this.sale.find(item => item.totalSale);
      return totalSaleItem && totalSaleItem.totalSale ? totalSaleItem.totalSale.toFixed(2) : 0;
    },
    totalTax() {
      const totalSaleItem = this.sale.find(item => item.totalTax);
      return totalSaleItem && totalSaleItem.totalTax ? totalSaleItem.totalTax.toFixed(2) : 0;
    },
    totalDiscount() {
      const totalSaleItem = this.sale.find(item => item.totalDiscount);
      return totalSaleItem && totalSaleItem.totalDiscount ? totalSaleItem.totalDiscount.toFixed(2) : 0;
    },
    totalDeliveryFee() {
      const totalSaleItem = this.sale.find(item => item.totalDeliveryFee);
      return totalSaleItem && totalSaleItem.totalDeliveryFee ? totalSaleItem.totalDeliveryFee.toFixed(2) : 0;
    },
    totalNetSale() {
      const totalSaleItem = this.sale.find(item => item.totalNetSale);
      return totalSaleItem && totalSaleItem.totalNetSale ? totalSaleItem.totalNetSale.toFixed(2) : 0;
    },
    filteredSale() {
      // Filter out items with 'totalSale'
      return this.sale.filter(item => item.hasOwnProperty("itemName"));
    },
    saleOnCash() {
      const saleOnCash = this.sale.find(item => item.saleOnCash);
      return saleOnCash && saleOnCash.saleOnCash ? saleOnCash.saleOnCash.toFixed(2) : 0;
    },
    saleOnCard() {
      const saleOnCard = this.sale.find(item => item.saleOnCard);
      return saleOnCard && saleOnCard.saleOnCard ? saleOnCard.saleOnCard.toFixed(2) : 0;
    }
  }
}
</script>
<style scoped>

</style>